import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import { useAuth } from '../contexts/AuthContext';

const LandingPage: React.FC = () => {
  const { user, isProvider, isClient } = useAuth();
  const navigate = useNavigate();

  // Redirect authenticated users to their dashboard
  useEffect(() => {
    if (user && isClient) {
      navigate('/client-dashboard', { replace: true });
    } else if (user && isProvider) {
      navigate('/provider-dashboard', { replace: true });
    }
  }, [user, isClient, isProvider, navigate]);

  return (
    <div className="app">
      <Header showSessionStatus={true} sessionActive={false} />
      
      <main id="main-content" className="page">
        <div className="container" style={{ paddingTop: '2rem' }}>
          {/* Hero Section */}
          <div className="text-center" style={{ marginBottom: '4rem' }}>
            <h1 
              style={{ 
                fontSize: '3rem', 
                marginBottom: '1rem',
                color: '#D4A017',
                backgroundClip: 'text',
                textAlign: 'center'
              }}
            >
              Welcome to My ClinicCore
            </h1>
            <p 
              style={{ 
                fontSize: '1.25rem', 
                maxWidth: '600px', 
                margin: '0 auto 2rem',
                color: '#d1d5db',
                textAlign: 'center'
              }}
            >
              The power behind every thriving practice!
            </p>
            
            {/* Call to Action Buttons */}
            <div style={{ 
              display: 'flex', 
              gap: '1rem', 
              justifyContent: 'center', 
              marginBottom: '3rem',
              flexWrap: 'wrap'
            }}>
              <Link
                to={user && isClient ? '/client-dashboard' : '/client-login'}
                className="btn btn-primary"
                style={{
                  padding: '1rem 2rem',
                  fontSize: '1rem',
                  fontWeight: 'bold',
                  textDecoration: 'none'
                }}
              >
                Client Portal
              </Link>
              <Link
                to={user && isProvider ? '/provider-dashboard' : '/provider-login'}
                className="btn btn-secondary"
                style={{
                  padding: '1rem 2rem',
                  fontSize: '1rem',
                  fontWeight: 'bold',
                  textDecoration: 'none'
                }}
              >
                Provider Portal
              </Link>
            </div>
          </div>

          {/* Features Grid */}
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
            gap: '2rem',
            marginBottom: '4rem'
          }}>
            {/* Feature Card 1 */}
            <div className="card">
              <div style={{ 
                fontSize: '2.5rem', 
                marginBottom: '1rem',
                textAlign: 'center'
              }}>
          
              </div>
              <h2 style={{
                fontSize: '1.25rem',
                fontWeight: '600',
                marginBottom: '0.5rem',
                textAlign: 'center',
                color: '#f9fafb'
              }}>
                Video Consultations
              </h2>
              <p style={{ 
                color: '#d1d5db', 
                textAlign: 'center',
                lineHeight: '1.6'
              }}>
                Secure video calls with recording capabilities and real-time transcription for comprehensive session documentation.
              </p>
            </div>
            
            {/* Feature Card 2 */}
            <div className="card">
              <div style={{ 
                fontSize: '2.5rem', 
                marginBottom: '1rem',
                textAlign: 'center'
              }}>
                
              </div>
              <h2 style={{
                fontSize: '1.25rem',
                fontWeight: '600',
                marginBottom: '0.5rem',
                textAlign: 'center',
                color: '#f9fafb'
              }}>
                Voice Commands
              </h2>
              <p style={{ 
                color: '#d1d5db', 
                textAlign: 'center',
                lineHeight: '1.6'
              }}>
                Hands-free session control with voice commands. Start sessions, save notes, and navigate without touching your device.
              </p>
            </div>
            
            {/* Feature Card 3 */}
            <div className="card">
              <div style={{ 
                fontSize: '2.5rem', 
                marginBottom: '1rem',
                textAlign: 'center'
              }}>
                
              </div>
              <h2 style={{
                fontSize: '1.25rem',
                fontWeight: '600',
                marginBottom: '0.5rem',
                textAlign: 'center',
                color: '#f9fafb'
              }}>
                Session Management
              </h2>
              <p style={{ 
                color: '#d1d5db', 
                textAlign: 'center',
                lineHeight: '1.6'
              }}>
                Advanced session timing, automatic billing calculations, and comprehensive session notes with audio transcription.
              </p>
            </div>
          </div>

          {/* Bottom CTA Section */}
          <div 
            className="card"
            style={{ 
              textAlign: 'center',
              background: '#374151',
              border: '1px solid #D4A017',
              boxShadow: '0 0 20px rgba(16, 185, 129, 0.1)'
            }}
          >
            <h2 style={{ 
              fontSize: '1.5rem', 
              marginBottom: '1rem',
              color: '#D4A017'
            }}>
              Ready to Start
            </h2>
            <p style={{ 
              color: '#d1d5db', 
              marginBottom: '2rem',
              fontSize: '1rem'
            }}>
              Join healthcare providers and clients who trust My ClinicCore for secure, efficient telehealth solutions.
            </p>
            <div style={{
              display: 'flex',
              gap: '1rem',
              justifyContent: 'center',
              flexWrap: 'wrap'
            }}>
              <Link
                to="/client-login"
                className="btn btn-primary"
                style={{ fontSize: '1rem', textDecoration: 'none' }}
              >
                Access Client Portal
              </Link>
              <Link
                to="/provider-login"
                className="btn btn-secondary"
                style={{ fontSize: '1rem', textDecoration: 'none' }}
              >
                Access Provider Login
              </Link>
              <Link
                to="/credentialing"
                className="btn btn-primary"
                style={{
                  fontSize: '1rem',
                  textDecoration: 'none'
                }}
              >
                Interested in Credentialing
              </Link>
            </div>
          </div>
          
          <div style={{ marginTop: '3rem', textAlign: 'center' }}>
            <p style={{ color: '#d1d5db' }}>
              © 2026 ClinicCore Inc. All rights reserved.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default LandingPage;